export function toDateSafe(v: any): Date | null {
  if (!v) return null;

  // Native Date
  if (v instanceof Date) return v;

  // Firestore Timestamp (client SDK)
  if (typeof v?.toDate === 'function') {
    try {
      const d = v.toDate();
      return d instanceof Date ? d : null;
    } catch {
      return null;
    }
  }

  // Milliseconds since epoch
  if (typeof v === 'number' && Number.isFinite(v)) {
    const d = new Date(v);
    return Number.isFinite(d.getTime()) ? d : null;
  }

  // ISO/date string
  if (typeof v === 'string') {
    const t = Date.parse(v);
    return Number.isFinite(t) ? new Date(t) : null;
  }

  // Firestore Timestamp-like object { seconds, nanoseconds }
  const sec = (v as any)?.seconds;
  const nanos = (v as any)?.nanoseconds;
  if (typeof sec === 'number' && Number.isFinite(sec)) {
    const ms = sec * 1000 + (typeof nanos === 'number' && Number.isFinite(nanos) ? Math.floor(nanos / 1e6) : 0);
    const d = new Date(ms);
    return Number.isFinite(d.getTime()) ? d : null;
  }

  return null;
}

export function toMsSafe(v: any): number | null {
  const d = toDateSafe(v);
  if (!d) return null;
  const t = d.getTime();
  return Number.isFinite(t) ? t : null;
}

